import { __decorate } from "tslib";
import { Route } from '../core';
import config from '../config';
var Bid2Void = /*@__PURE__*/ (function () {
    function Bid2Void() {
    }
    Bid2Void.get = function (response) {
        return response;
    };
    Bid2Void = __decorate([
        Route(config.BID2VOID_URL, config.BID2VOID_URL.indexOf('http') > -1)
    ], Bid2Void);
    return Bid2Void;
}());
export { Bid2Void };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/endpoints/bid2void.ts
// module id = null
// module chunks = 